import { KTSVG } from "_metronic/helpers"
import { FC } from "react"
import Tooltip from "../Tooltip";

type ThemeColors = {
    white: string;
    primary: string;
    secondary: string;
    success: string;
    info: string;
    warning: string;
    danger: string;
    light: string;
    dark: string;
};
type ThemeColorKeys = keyof ThemeColors;

type Props = {
    message?: string,
    /**
     * Default value is primary
     */
    bgColor?: ThemeColorKeys,
    bgBorder?: ThemeColorKeys,
    textColor?: ThemeColorKeys,
    textSize?: string,
    svgColor?: ThemeColorKeys,
    /**
     * Size are 1...n
     */
    svgSize?: string,
    maxWidth?: string
    maxHeight?: string
    marginRight?: string
}

const AlertInfoComponent: FC<Props> = ({ message, bgColor = "primary", textColor, svgColor, maxWidth, maxHeight, svgSize, textSize, bgBorder, marginRight = "0" }) => {
    return (
        <div
            className={`alert alert-dismissible bg-light-${bgColor} border-${bgBorder} d-flex flex-column flex-sm-row p-5 mb-0`}
            style={{ alignItems: "center", maxWidth: maxWidth, maxHeight: maxHeight }}
        >
            <Tooltip content={message} hoverable={true} type="info" display="100" side="top">
                <span className={`svg-icon svg-icon-${svgSize}hx svg-icon-${svgColor} me-${marginRight} mb-5 mb-sm-0`}>
                    <KTSVG path="/media/icons/duotune/general/gen045.svg" className="svg-icon-1 fs-7" />
                </span>
            </Tooltip>
        </div>
    );
}

export { AlertInfoComponent }